import { BLUE, RED, CAPTURED } from '../../constants';
import { setupPieces } from '../../game/setup';
import { movePiece, cycleToRack, cycleToEnteringSpace } from '../../game/moves';
import { enumerate } from '../../game/ai';

export const InputGame = {
  setup: () => {
    let pieces = setupPieces();
    return {
      name: 'Input',
      cells: Array(12).fill(null),
      enteringSpace: {
        [RED]: [],
        [BLUE]: [],
      },
      pieces,
    };
  },
  turn: { moveLimit: 1 },
  moves: { movePiece, cycleToRack, cycleToEnteringSpace },
  endIf: (G, ctx) => {
    let redPieces = G.pieces.filter(
      (piece) => piece.color === RED && piece.currentPos !== CAPTURED
    );
    let bluePieces = G.pieces.filter(
      (piece) => piece.color === BLUE && piece.currentPos !== CAPTURED
    );
    if (redPieces.length === 0) {
      return { winner: BLUE };
    } else if (bluePieces.length === 0) {
      return { winner: RED };
    }
  },
  ai: { enumerate },
};
